export interface NormalizedCoords {
  x: number;
  y: number;
}

// normalizeCoords 把 clientX/clientY 转成 target 内归一化 [0, 1] 坐标。
// getBoundingClientRect 在 visualViewport 变化、iOS 虚拟键盘弹出、页面滚动时
// 返回最新值,因此不需要额外挂 visualViewport 监听。
export function normalizeCoords(
  target: Element,
  clientX: number,
  clientY: number,
): NormalizedCoords {
  const rect = target.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return { x: 0, y: 0 };
  return {
    x: clamp01((clientX - rect.left) / rect.width),
    y: clamp01((clientY - rect.top) / rect.height),
  };
}

function clamp01(v: number): number {
  if (Number.isNaN(v)) return 0;
  if (v < 0) return 0;
  if (v > 1) return 1;
  return v;
}
